import React from 'react'

import NavItem from './navItem'

interface INavItem {
  link: string
  label: string
}

interface IProps {
  items: INavItem[]
  noMargin?: boolean
  actions?: any
}

const SubNavigation: React.FC<IProps> = ({ items, actions, noMargin }) => {
  return (
    <header
      className={`h-50 px-48${
        noMargin ? '' : ' mb-65'
      } flex justify-between items-center relative t-0 l-0 r-0 border-b-1 border-black`}
    >
      <nav className="h-full">
        <ul className="h-full flex flex-row items-center">
          {items.map(item => (
            <NavItem key={item.link} linkTo={item.link}>
              {item.label}
            </NavItem>
          ))}
        </ul>
      </nav>
      <div className="flex items-center">{actions}</div>
    </header>
  )
}

export default SubNavigation
